import PageBox from "PFComponents/box/page_box";
import Toggle from "PFComponents/toggle/toggle";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

const Avatar = ({ data, disabledItems, setDisabledItems }) => {
  const { t } = useTranslation("changeRequests");
  if (!data?.avatar?.url) {
    return false;
  }

  const isDisabled = disabledItems.avatar;

  return (
    <PageBox style={{ padding: 20, marginBottom: 20 }} qaId="ChangeRequest.Avatar">
      <h2 style={{ marginTop: 0 }}>
        {t("parts.avatar")}
        <div style={{ float: "right" }}>
          <Toggle
            checked={!isDisabled}
            onChange={(val) => setDisabledItems((prev) => ({ ...prev, avatar: !val }))}
          />
        </div>
      </h2>
      <div style={{ textAlign: "center", marginTop: 20, opacity: isDisabled ? 0.6 : 1 }}>
        <img src={data.avatar.url} alt="new avtar" style={{ width: 120, height: 120, borderRadius: 60 }} />
      </div>
    </PageBox>
  );
};

Avatar.propTypes = {
  data: PropTypes.shape({
    avatar: PropTypes.shape({ url: PropTypes.string }).isRequired
  }),
  disabledItems: PropTypes.shape({ avatar: PropTypes.bool }).isRequired,
  setDisabledItems: PropTypes.func.isRequired
};

export default Avatar;
